import Avatar from './avatar'
// import Group from './avatar-group'

// Avatar.Group = Group

export default Avatar
